import * as React from 'react';
import { createApiClient } from '../../../services/ApiClient';
import { Modal, Button} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {parseTagSanitizeAndWhitelist} from "../../../modules/metajson-sub/src/libs/helpers/Utils";


interface StatusRequest {
    createTime: string;
    newStatusId: number;
    oldStatusId: number;
    user: string;
    comment: string;
}

interface State {
    form: string;
    request: number;
    history: Array<StatusRequest>;
    show: boolean;
}

const statusFormate = (cell) => {
    switch (cell) {
        case 'Черновик': return (<span className="label label-primary">Черновик</span>);
        case 'На рассмотрении Фонда': return (<span className="label label-default">На рассмотрении Фонда</span>);
        case 'Одобрена': return (<span className="label label-success">Одобрена</span>);
        case 'Отправлено': return (<span className="label label-default">Отправлено</span>);
        case 'Отклонена': return (<span className="label label-danger">Отклонена</span>);
        case 'Ожидание PDF': return (<span className="label label-default">Ожидание PDF</span>);
        case 'Запрошены документы': return (<span className="label label-info" style={{whiteSpace:"pre-line"}}>Запрошены документы</span>);
        case 'На рассмотрении': return (<span className="label label-success" style={{whiteSpace:"pre-line"}}>На рассмотрении</span>);
        case 'Документы отправлены': return (<span className="label label-success" style={{whiteSpace:"pre-line"}}>Документы отправлены</span>);
        case 'Отозвана': return (<span className="label label-danger">Отозвана</span>);
        case 'Дополнительный запрос': return (<span className="label label-warning" title="Дополнительный запрос">Дополнительный запрос</span>);
        default: return (<span className="label label-info" style={{whiteSpace:"pre-line"}}>{cell}</span>);
    }
}

const userFormate = (cell) => {
    switch (cell) {
        case 1:
            return 'АСУ'
        case 2:
            return 'Вы'
        case 3:
            return 'Компания'
        case 4:
            return 'Верификатор'
        case null:
        default:
                return ''

    }
}

const dateFormatter = (cell, row) => {
    const date = new Date(cell);

    if (date instanceof Date) {
        // const date = new Date(Date.UTC(sourceDate.getFullYear(), sourceDate.getMonth(), sourceDate.getDate(), sourceDate.getHours(), sourceDate.getMinutes(), sourceDate.getSeconds()));
        return `${('0' + date.getDate()).slice(-2)}.${('0' + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()} ${('0' + (date.getHours())).slice(-2)}:${('0' + (date.getMinutes())).slice(-2)}`;
    }

    return null
}

const commentFormat = (cell) => {
    return <div>
        {
            parseTagSanitizeAndWhitelist(cell, ['p', 'div', 'span'])
        }
    </div>
}

class HistoryStatusModal extends React.Component<{}, State>{
    state = {
        form: "",
        request: 0,
        history: [],
        show: false
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    public show = (request: number) => {
        this.setState({
            request,
            show: true,
            history: []
        })
    }

    onEnter = () => {
        const client = createApiClient();
        const { request } = this.state;

        client.getHistory(request,{
            success: (data) =>{
                this.setState({ history: data });
            }
        });
    }

    render() {
        const config ={
            height: '310px',
            options: {
                noDataText: 'У вас пока нет историй изменений статусов в заявке ',
            }
        }

        return (
          // @ts-ignore
            <Modal onEnter={this.onEnter} show={this.state.show} onHide={this.handleClose}>
                {/*// @ts-ignore*/}
                <Modal.Header closeButton>
                    {/*// @ts-ignore*/}
                    <Modal.Title>История</Modal.Title>
                </Modal.Header>
                {/*// @ts-ignore*/}
                <Modal.Body>
                   <BootstrapTable {...config} data={this.state.history} >
                        <TableHeaderColumn dataField='index' isKey={true} hidden></TableHeaderColumn>
                        <TableHeaderColumn dataField='created_at' dataFormat={dateFormatter} width="120px">Дата изменения</TableHeaderColumn>
                        <TableHeaderColumn dataField='status'  dataFormat={statusFormate} width="150px">Новый статус</TableHeaderColumn>
                        <TableHeaderColumn dataField='comment' dataFormat={commentFormat} >Комментарий</TableHeaderColumn>
                   </BootstrapTable>
                </Modal.Body>

                {/*// @ts-ignore*/}
                <Modal.Footer>
                    {/*// @ts-ignore*/}
                    <Button onClick={this.handleClose}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default HistoryStatusModal;
